module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-collapse-item', {
    attrs: {
      "title": "Chip " + _vm.chip.id + " " + _vm.getLastTestResult(_vm.chip)
    }
  }, [_vm._l((_vm.chip.positions), function(pos, ipos) {
    return _c('h4', [_vm._v("Position " + _vm._s(pos.position.X) + "x" + _vm._s(pos.position.Y) + " to corrected " + _vm._s(pos.corrected_position.X) + "x" + _vm._s(pos.corrected_position.Y))])
  }), _vm._v(" "), (_vm.chip.tests.length > 0) ? _c('div', [_c('h4', [_vm._v("Tests")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.chip.tests
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Date",
      "width": "190"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatTestTime(scope.row.timestamp)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Type",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatTestType(scope.row.type)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Timespan",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatTestTimespan(scope.row.timespan)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Result",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatResult(scope.row)))])]
      }
    }])
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getCodes && _vm.getCodes.length > 0) ? _c('div', [_c('h4', [_vm._v("Codes")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.getCodes
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "Type",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "data",
      "label": "Data",
      "width": "350"
    }
  })], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0da0c506","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chip-data.vue
// module id = 707
// module chunks = 1